import { render, staticRenderFns } from "./freightPopup.vue?vue&type=template&id=0f638b0a&scoped=true&"
import script from "./freightPopup.vue?vue&type=script&lang=ts&"
export * from "./freightPopup.vue?vue&type=script&lang=ts&"
import style0 from "./freightPopup.vue?vue&type=style&index=0&id=0f638b0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f638b0a",
  null
  
)

export default component.exports